const DEFAULT_CONTACT_EMAIL = 'sales@extremefei.com'
export const PROJECT_MANAGEMENT_CONTACT_EMAIL = 'fanxin.kong@extremefei.com'
const CRM_LEAD_ENDPOINT = 'https://www.stellarlae.com:1002/api/crmLeads/public/add'

function contactEmailEndpoint(to = DEFAULT_CONTACT_EMAIL) {
  return `https://formsubmit.co/ajax/${to}`
}

export async function submitCrmLead({
  leadsName = '',
  telephone = '',
  mobile = '',
  email = '',
  address = '',
  remark = '',
  nextTime = '',
}) {
  const response = await fetch(CRM_LEAD_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      leadsName,
      telephone,
      mobile,
      email,
      address,
      remark,
      nextTime,
    }),
  })

  if (!response.ok) {
    throw new Error('客户线索提交失败')
  }

  return response.json().catch(() => ({}))
}

export async function submitContactEmail({
  subject,
  contact,
  name,
  company,
  messageLines = [],
  to = DEFAULT_CONTACT_EMAIL,
}) {
  const response = await fetch(contactEmailEndpoint(to), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify({
      _subject: subject,
      _template: 'table',
      ...(name ? { name } : {}),
      ...(contact ? { contact } : {}),
      ...(company ? { company } : {}),
      message: messageLines.join('\n'),
    }),
  })

  if (!response.ok) {
    throw new Error('邮件发送失败')
  }

  const result = await response.json().catch(() => ({}))
  if (result.success === 'false' || result.success === false) {
    throw new Error(result.message || '邮件发送失败')
  }

  return result
}
